import { Icon, IconProps } from './Icon';

export type DiscordProps = IconProps;

const Discord = (props: DiscordProps) => (
  <Icon fill="none" viewBox="0 0 22 17" {...props}>
    <path
      fill="currentColor"
      d="M14.097 0c-.215.39-.408.792-.584 1.203a16.682 16.682 0 0 0-5.036 0A12.117 12.117 0 0 0 7.893 0a18.08 18.08 0 0 0-4.54 1.427C.482 5.76-.295 9.983.092 14.147a18.113 18.113 0 0 0 5.567 2.848c.452-.617.851-1.274 1.193-1.958a11.966 11.966 0 0 1-1.878-.913c.158-.116.312-.237.461-.353a12.848 12.848 0 0 0 11.131 0c.15.125.303.246.46.353a11.85 11.85 0 0 1-1.881.917c.342.684.741 1.342 1.193 1.959a18.105 18.105 0 0 0 5.568-2.845c.456-4.83-.781-9.016-3.27-12.724A17.802 17.802 0 0 0 14.102.01zM7.345 11.584c-1.084 0-1.983-1.002-1.983-2.24 0-1.24.864-2.246 1.978-2.246s2.001 1.01 1.983 2.245c-.017 1.235-.873 2.24-1.978 2.24zm7.31 0c-1.089 0-1.98-1.002-1.98-2.24 0-1.24.865-2.246 1.98-2.246s1.996 1.01 1.978 2.245c-.018 1.235-.873 2.24-1.979 2.24z"
    />
  </Icon>
);

export { Discord };
